import { render, staticRenderFns } from "./CompanyLayout.vue?vue&type=template&id=728f5188&scoped=true&"
import script from "./CompanyLayout.vue?vue&type=script&lang=ts&"
export * from "./CompanyLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyLayout.vue?vue&type=style&index=0&id=728f5188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f5188",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
